import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { LazyModule } from 'owa-bundling';
import { runAfterInitialRender } from 'owa-delayed-initialization';
import { showNotificationOnMailboxQuotaWarning } from 'owa-mail-triage-action';
var lazySubscribeToMailNotifications = new LazyModule(function () {
    return System.import(
    /* webpackChunkName: "Notifications" */ './orchestrators/handleNewMailNotification');
});
runAfterInitialRender(function () {
    if (isMailFeatureEnabled('fwk-webNotification')) {
        lazySubscribeToMailNotifications.import();
    }
    showNotificationOnMailboxQuotaWarning();
});
//# sourceMappingURL=index.js.map